import axios from './index'

// 登录判断有无集训
export const isHaveTrain = params => {
    return axios.post(`api/8720/student/isHaveTrain`, params)
}
// 判断该次集训是否需要前测
export const isHaveEntranceTest = params => {
    return axios.post(`api/8740/testResult/getIsHaveBeforeTest`, params)
}
// 查询我的断点
export const getMyBreakpoint = params => {
    return axios.post(`api/8740/myBreakpoint/getMyBreakpoint`, params)
}
// 获取单词类型
export const wordType = params => {
    return axios.post(`api/8720/student/getTypeAndCheck`, params)
}
// 根据单词类型获取版本
export const isHaveBb = params => {
    return axios.post(`api/8720/student/isHaveBb`, params)
}
// 根据版本获取章
export const isHaveZ = params => {
    return axios.post(`api/8720/student/isHaveZ`, params)
}
// 屏幕状态
export const getPmzt = params => {
    return axios.post(`api/8710/classOnOff/getPmzt`, params)
}
// 根据班级获取集训
export const getTrainingUsTime = params => {
    return axios.post(`api/8400/training/getTrainingUsTime`, params)
}
// 根据章获取单元
export const isHaveUnit = params => {
    return axios.post(`api/8720/student/selectUnitAndXj`, params)
}

// 根据单元下的单词
export const getWords = params => {
    return axios.post(`api/8720/words/selectWords`, params)
}
// 提交单词
export const submitWords = params => {
    return axios.post(`api/8720/words/saveWordsResult`, params)
}
export const saveWordFinishSnapshot = params => {
    return axios.post(`api/8720/words/saveWordFinishSnapshot`, params)
}
export const getRecoverableWordFinishSnapshot = params => {
    return axios.post(`api/8720/words/getRecoverableWordFinishSnapshot`, params)
}
export const abandonWordFinishSnapshot = params => {
    return axios.post(`api/8720/words/abandonWordFinishSnapshot`, params)
}
// 集训下拉框
export const getTrains = params => {
    return axios.get(`api/8100/trainings/selectTraining`, params)
}
// 根据集训查询班级和小组
export const getGroupStudentCount = params => {
    return axios.post(`api/8720/student/getGroupStudentCount`, params)
}
// 错题本首页数据
export const getErrorWordHome = params => {
    return axios.post(`api/8740/errorWord/getErrorWordHome`, params)
}
// 错词列表
export const getErrorWordList = params => {
    return axios.post(`api/8740/errorWord/getErrorWordList`, params)
}
// 巩固错词
export const getWrongWords = params => {
    return axios.post(`api/8720/words/errorWordConsolidate`, params)
}
// 学情分析
export const getStudyAnalysis = params => {
    return axios.post(`api/8720/studyAnalysis/getStudyAnalysis`, params)
}
// 学生金币总数
export const goldSum = params => {
    return axios.get(`api/8740/studentCoin/getStudentCoinTotal`, params)
}
// 金币排行榜
export const getCoinRanking = params => {
    return axios.post(`api/8720/studentCoinDetail/getCoinRanking`, params)
}
// 查询该学生测试成绩
export const getTestList = params => {
    return axios.post(`api/8740/testResult/getTestList`, params)
}
// 查询该学生金币明细
export const getCoinsList = params => {
    return axios.post(`api/8720/studentCoinDetail/getStudentCoinDetailList`, params)
}
// 保存该学生学习记录
export const saveMyBreakpoint = params => {
    return axios.post(`api/8720/words/saveMyBreakpoint`, params)
}
// 意见反馈提交
export const addFeedback = params => {
    return axios.post(`api/8720/feedback/addFeedback`, params)
}
// 分页查询物品
export const selectExchangeItemsPage = (params) => {
    return axios.post(`api/8700/exchangeItems/selectExchangeItemsPage`, params)
}
// 发起兑换
export const saveItemExchange = (params) => {
    return axios.post(`api/8700/itemExchange/saveItemExchange`, params)
}
// 获取班级（常规班）id
export const selectClassByYhid = (params) => {
    return axios.get(`api/8100/class/selectClassByYhid`, params)
}
// 收藏单词
export const updateCollectionWord = (params) => {
    return axios.post(`api/8720/collectionWord/updateCollectionWord`, params)
}
// 我的收藏
export const myCollectionWord = (params) => {
    return axios.post(`api/8720/collectionWord/myCollectionWord`, params)
}
// 移除收藏
export const deleteCollectionWord = (params) => {
    return axios.post(`api/8720/collectionWord/deleteCollectionWord`, params)
}
// 新增个性化设置
export const addPersonalConfig = (params) => {
    return axios.post(`api/8720/personalConfig/addPersonalConfig`, params)
}
// 我的个性化设置
export const myPersonalConfig = (params) => {
    return axios.post(`api/8720/personalConfig/myPersonalConfig`, params)
}
// 修改个性化设置
export const updatePersonalConfig = (params) => {
    return axios.post(`api/8720/personalConfig/updatePersonalConfig`, params)
}
// 获取学习小贴士
export const getStudytips = (params) => {
    return axios.post(`api/8720/studyAnalysis/getStudytips`, params)
}

// ================前后测试=======================
// 结业测试 / 入学测试 获取下一题
export const nextItem = params => {
    return axios.get(`/api/8760/wordItem/suggest`, params)
}
// 结业测试 / 入学测试 提交答案
export const submitTotalTest = params => {
    return axios.post(`/api/8760/answerItem/submit`, params)
}
// 结业测试 / 入学测试 交卷
export const submitTest = params => {
    return axios.post(`/api/8760/pkAdmissionTest/submitTestV2`, params)
}
// 结业测试 / 入学测试 成绩查询
export const getMyTestResult = params => {
    return axios.post(`/api/8760/pkAdmissionTest/getMyTest`, params)
}


// 获取最新一次已经结束的集训 班级 小组信息

export const getAfterTrain = params => {
    return axios.post(`/api/8720/afterTrain/getStudentInfo`, params)
}


// 获取集训未完成的单词速记的类型
export const getLastType = params => {
    return axios.post(`/api/8720/afterTrain/getLastType`, params)
}

// 获取集训该类型下单词速记的版本
export const getLastBb = params => {
    return axios.post(`/api/8720/afterTrain/getLastBb`, params)
}
// 根据版本获取章
export const getLastZ = params => {
    return axios.post(`api/8720/afterTrain/getLastZ`, params)
}
// 获取章下未学习完的单元信息
export const getLastUnit = params => {
    return axios.post(`api/8720/afterTrain/getLastUnit`, params)
}
//获取集训下的熟词信息
export const getFamiliarWord = params => {
    return axios.post(`api/8720/student/getFamiliarWords`, params)
}


//课后复习接口

// 获取最新一次已经结束的集训,班级,小组信息
export const getReviewInfo = params => {
    return axios.post(`api/8720/trainReview/getStudentInfo`, params)
}


// 获取集训下复习的单词速记的类型
export const getReviewLastType = params => {
    return axios.post(`/api/8720/trainReview/getTrainReviewType`, params)
}

// 获取集训下该类型复习的单词速记的版本
export const getReviewLastBb = params => {
    return axios.post(`/api/8720/trainReview/getTrainReviewBb`, params)
}
// 获取版本下已学习完的章信息
export const getReviewLastZ = params => {
    return axios.post(`api/8720/trainReview/getTrainReviewZ`, params)
}
// 获取章下已学习完的单元信息
export const getReviewLastUnit = params => {
    return axios.post(`api/8720/trainReview/getTrainReviewUnit`, params)
}

//保存复习断点

export const saveBreakpoint = params => {
    return axios.post(`api/8720/words/saveReviewBreakpoint`, params)
}
// 获取单元下复习的单词
export const getReviewWords = params => {
    return axios.post(`api/8720/words/selectReviewWords`, params)
}

// 查询我的断点
export const getMyReviewBreakpoint = params => {
    return axios.post(`api/8740/myBreakpoint/getReviewBreakpoint`, params)
}

export const submitReviewWords = params => {
    return axios.post(`api/8720/words/saveReviewWordsResult`, params)
}

// 课后复习数据查询
export const queryReview = params => {
    return axios.post(`api/8720/student/getReviewWordsPage`, params)
}

//单词阅读小短文
export const wordArticle  = params => {
    return axios.post(`api/8720/wordsRead/selectWordsReadPage`, params)
}

// 随机获取测试题目20题
export const getQuestion  = params => {
    return axios.post(`api/9210/mindTest/selectmindTestRandom`, params)
}
// 保存测试记录
export const saveRecord = params => {
    return axios.post(`api/9210/mindTestRecord/saveMindTestRecord`, params)
}
// 获取智谱AI接口鉴权token
export const getAuthenticationToken = params => {
    return axios.post(`api/8100/apToken/getApToken`,params)
}
